import clsx from 'clsx';
import React, { useContext } from 'react';

import { FlagsContext } from 'src/context';
import { MultiSelectOption } from 'src/legacy/components/Select/types';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BaseChip, TruncatedText } from 'src/legacy/components/UI';
import { LightGray } from 'src/theme/colors';
import ColorUtils from 'src/utils/ColorUtils';

interface MultiSelectInputProps {
  selectedTags: Array<MultiSelectOption>;
  tagsLimit?: number;
}

export const MultiSelectInput: React.FC<MultiSelectInputProps> = ({
  selectedTags,
  tagsLimit = 3,
}) => {
  const { EnableCrmRightSidebarRedesign } = useContext(FlagsContext);
  return selectedTags ? (
    <div
      className={clsx('flex items-center flex-wrap cursor-pointer ', {
        'w-[190px]': EnableCrmRightSidebarRedesign,
        'w-[200px]': !EnableCrmRightSidebarRedesign,
      })}
    >
      {selectedTags.map((optionValue, index) => {
        const showOption = tagsLimit ? index < tagsLimit : true;
        return (
          showOption && (
            <div key={optionValue.id} className="p-1">
              <BaseChip
                label={
                  <TruncatedText
                    styleProps={{
                      color: optionValue.color,
                    }}
                    text={optionValue.label}
                    maxChars={10}
                  />
                }
                style={{
                  backgroundColor: ColorUtils.GetColorDarknessShades(
                    optionValue.color,
                  ).light,
                  cursor: 'pointer',
                }}
              />
            </div>
          )
        );
      })}
      {tagsLimit && (selectedTags?.length ?? 0) > tagsLimit && (
        <BaseTypography fontType="12Medium" style={{ color: LightGray }}>
          + {(selectedTags?.length ?? 0) - tagsLimit}
        </BaseTypography>
      )}
    </div>
  ) : null;
};
